import {
  DropdownAddLineItemGroup,
  SectionLineItems
} from 'Invoices/components/CreateEditShared'
import { Section } from '../components'
import { useIsInvoiceEditable } from 'Invoices/hooks/useIsInvoiceEditable'

export const LineItems = () => {
  const isEditable = useIsInvoiceEditable()
  return (
    <Section title="Items">
      <SectionLineItems
        tableFooter={
          isEditable && (
            <DropdownAddLineItemGroup showDropdownInitially={false} />
          )
        }
      />
    </Section>
  )
}
